export default [
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../../../src/views/Login.vue")
  },
  {
    path: "/access-denied",
    name: "accessDenied",
    component: () =>
      import(/* webpackChunkName: "accessDenied" */ "../../../src/views/AccessDenied.vue")
  }
]
